(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    


/* =========================================================
   LOAD PRODUCT RECOMMENDATIONS
   ========================================================= */

var loadProductRecommendationsIntoSection = function() {

  var section =
    document.querySelector(".related-products");


  if (!section) {

    return;

  }


  var request =
    new XMLHttpRequest();


  request.open(
    "GET",
    section.dataset.url
  );


  request.onload = function() {

    if (
      request.status >= 200 &&
      request.status < 300
    ) {

      var container =
        document.createElement("div");


      container.innerHTML =
        request.response;


      var newContent =
        container.querySelector(
          ".related-products"
        );


      if (
        newContent &&
        newContent.querySelector(
          ".product-block"
        )
      ) {

        section.innerHTML =
          newContent.innerHTML;


        section.classList.add(
          "scroll-animation"
        );


        initCarousel(section);


        initScrollAnimation(section);

      }

    }

  };


  request.onerror = function() {

    console.warn(
      "Unable to load product recommendations."
    );

  };


  request.send();

};


/* =========================================================
   INFINITE PRODUCT CAROUSEL
   ========================================================= */

var initCarousel = function(section) {

  var carousel =
    section.querySelector(
      ".product-carousel"
    );


  if (!carousel) {

    return;

  }


  var prevBtn =
    section.querySelector(
      ".carousel-prev"
    );


  var nextBtn =
    section.querySelector(
      ".carousel-next"
    );


  var dotsContainer =
    section.querySelector(
      ".carousel-dots"
    );


  var originalItems =
    Array.from(
      carousel.querySelectorAll(
        ".carousel-item"
      )
    );


  if (!originalItems.length) {

    return;

  }


  /*
    We need at least 5 products
    for the exact 1-2-3-4 →
    2-3-4-5 → looping effect.
  */

  if (originalItems.length < 5) {

    initSimpleCarousel(
      section,
      carousel,
      originalItems,
      prevBtn,
      nextBtn,
      dotsContainer
    );

    return;

  }


  /* -------------------------------------------------------
     Clone products
     ------------------------------------------------------- */

  var itemsCount =
    originalItems.length;


  /*
    Clone the entire product set
    before and after the original set.

    Example:

    [1 2 3 4 5]
    [1 2 3 4 5]
    [1 2 3 4 5]
  */

  var beforeFragment =
    document.createDocumentFragment();


  var afterFragment =
    document.createDocumentFragment();


  originalItems.forEach(
    function(item) {

      var beforeClone =
        item.cloneNode(true);


      var afterClone =
        item.cloneNode(true);


      beforeFragment.appendChild(
        beforeClone
      );


      afterFragment.appendChild(
        afterClone
      );

    }
  );


  carousel.insertBefore(
    beforeFragment,
    carousel.firstChild
  );


  carousel.appendChild(
    afterFragment
  );


  var allItems =
    Array.from(
      carousel.querySelectorAll(
        ".carousel-item"
      )
    );


  /*
    Position at the middle copy.

    This means the user initially sees:

    1 2 3 4
  */

  var getItemWidth = function() {

    if (!allItems[0]) {

      return 0;

    }


    var style =
      window.getComputedStyle(
        carousel
      );


    var gap =
      parseFloat(style.gap) || 20;


    return (
      allItems[0].offsetWidth +
      gap
    );

  };


  var itemWidth =
    getItemWidth();


  /*
    Start at the second set.

    First set = clones
    Second set = real products
  */

  carousel.scrollLeft =
    itemWidth * itemsCount;


  /* -------------------------------------------------------
     Automatic scrolling
     ------------------------------------------------------- */

  var autoScrollTimer =
    null;


  var isAnimating =
    false;


  /* -------------------------------------------------------
     Move ONE product forward
     ------------------------------------------------------- */

  var moveNext = function() {

    if (isAnimating) {

      return;

    }


    itemWidth =
      getItemWidth();


    if (!itemWidth) {

      return;

    }


    isAnimating = true;


    carousel.scrollTo({

      left:
        carousel.scrollLeft +
        itemWidth,

      behavior:
        "smooth"

    });


    setTimeout(
      function() {

        isAnimating = false;

        normalizePosition();

        updateDots();

      },
      450
    );

  };


  /* -------------------------------------------------------
     Move ONE product backward
     ------------------------------------------------------- */

  var movePrevious = function() {

    if (isAnimating) {

      return;

    }


    itemWidth =
      getItemWidth();


    if (!itemWidth) {

      return;

    }


    isAnimating = true;


    carousel.scrollTo({

      left:
        carousel.scrollLeft -
        itemWidth,

      behavior:
        "smooth"

    });


    setTimeout(
      function() {

        isAnimating = false;

        normalizePosition();

        updateDots();

      },
      450
    );

  };


  /* -------------------------------------------------------
     Infinite position correction
     ------------------------------------------------------- */

  var normalizePosition = function() {

    itemWidth =
      getItemWidth();


    if (!itemWidth) {

      return;

    }


    var originalSetWidth =
      itemWidth *
      itemsCount;


    var minimumPosition =
      originalSetWidth * 0.5;


    var maximumPosition =
      originalSetWidth * 2.5;


    /*
      If user reaches the third copy,
      silently move back to middle copy.
    */

    if (
      carousel.scrollLeft >=
      maximumPosition
    ) {

      carousel.scrollLeft -=
        originalSetWidth;

    }


    /*
      If user reaches the first copy,
      silently move forward to middle copy.
    */

    else if (
      carousel.scrollLeft <=
      minimumPosition
    ) {

      carousel.scrollLeft +=
        originalSetWidth;

    }

  };


  /* -------------------------------------------------------
     Dots
     ------------------------------------------------------- */

  var updateDots = function() {

    if (!dotsContainer) {

      return;

    }


    /*
      For 5 products,
      there are 5 logical positions.
    */

    dotsContainer.innerHTML = "";


    for (
      var i = 0;
      i < itemsCount;
      i++
    ) {

      var dot =
        document.createElement(
          "button"
        );


      dot.type =
        "button";


      dot.className =
        "carousel-dot";


      dot.setAttribute(
        "data-index",
        i
      );


      dot.setAttribute(
        "aria-label",
        "Go to product " +
        (i + 1)
      );


      dot.addEventListener(
        "click",
        function() {

          var index =
            parseInt(
              this.getAttribute(
                "data-index"
              ),
              10
            );


          itemWidth =
            getItemWidth();


          /*
            Move to corresponding
            product in middle set.
          */

          carousel.scrollTo({

            left:
              itemWidth *
              (
                itemsCount +
                index
              ),

            behavior:
              "smooth"

          });


          restartAutoScroll();

        }
      );


      dotsContainer.appendChild(
        dot
      );

    }


    /*
      Calculate current logical position.
    */

    var middleStart =
      itemWidth *
      itemsCount;


    var relativePosition =
      Math.round(
        (
          carousel.scrollLeft -
          middleStart
        ) /
        itemWidth
      );


    var currentIndex =
      (
        relativePosition %
        itemsCount +
        itemsCount
      ) %
      itemsCount;


    var dots =
      dotsContainer.querySelectorAll(
        ".carousel-dot"
      );


    dots.forEach(
      function(dot, index) {

        dot.classList.toggle(
          "active",
          index === currentIndex
        );

      }
    );

  };


  /* -------------------------------------------------------
     Auto scroll
     ------------------------------------------------------- */

  var startAutoScroll = function() {

    stopAutoScroll();


    autoScrollTimer =
      setInterval(
        function() {

          moveNext();

        },
        10000
      );

  };


  /* -------------------------------------------------------
     Stop auto scroll
     ------------------------------------------------------- */

  var stopAutoScroll = function() {

    if (autoScrollTimer) {

      clearInterval(
        autoScrollTimer
      );

      autoScrollTimer = null;

    }

  };


  /* -------------------------------------------------------
     Restart timer
     ------------------------------------------------------- */

  var restartAutoScroll = function() {

    stopAutoScroll();

    startAutoScroll();

  };


  /* -------------------------------------------------------
     Next button
     ------------------------------------------------------- */

  if (nextBtn) {

    nextBtn.addEventListener(
      "click",
      function() {

        moveNext();

        restartAutoScroll();

      }
    );

  }


  /* -------------------------------------------------------
     Previous button
     ------------------------------------------------------- */

  if (prevBtn) {

    prevBtn.addEventListener(
      "click",
      function() {

        movePrevious();

        restartAutoScroll();

      }
    );

  }


  /* -------------------------------------------------------
     Mouse hover
     ------------------------------------------------------- */

  carousel.addEventListener(
    "mouseenter",
    function() {

      stopAutoScroll();

    }
  );


  carousel.addEventListener(
    "mouseleave",
    function() {

      startAutoScroll();

    }
  );


  /* -------------------------------------------------------
     Touch
     ------------------------------------------------------- */

  carousel.addEventListener(
    "touchstart",
    function() {

      stopAutoScroll();

    },
    {
      passive: true
    }
  );


  carousel.addEventListener(
    "touchend",
    function() {

      startAutoScroll();

    },
    {
      passive: true
    }
  );


  /* -------------------------------------------------------
     Manual scroll normalization
     ------------------------------------------------------- */

  carousel.addEventListener(
    "scroll",
    function() {

      updateDots();

    }
  );


  /* -------------------------------------------------------
     Resize
     ------------------------------------------------------- */

  window.addEventListener(
    "resize",
    function() {

      itemWidth =
        getItemWidth();


      carousel.scrollLeft =
        itemWidth *
        itemsCount;

      updateDots();

    }
  );


  /* -------------------------------------------------------
     Initial state
     ------------------------------------------------------- */

  updateDots();

  startAutoScroll();

};


/* =========================================================
   FALLBACK CAROUSEL
   Used when fewer than 5 products exist
   ========================================================= */

var initSimpleCarousel = function(
  section,
  carousel,
  items,
  prevBtn,
  nextBtn,
  dotsContainer
) {

  if (!items.length) {

    return;

  }


  var autoScrollTimer =
    null;


  var getAmount = function() {

    var style =
      window.getComputedStyle(
        carousel
      );


    var gap =
      parseFloat(style.gap) || 20;


    return (
      items[0].offsetWidth +
      gap
    );

  };


  var moveNext = function() {

    var amount =
      getAmount();


    if (
      carousel.scrollLeft >=
      carousel.scrollWidth -
      carousel.clientWidth -
      5
    ) {

      carousel.scrollTo({

        left: 0,

        behavior: "smooth"

      });

    } else {

      carousel.scrollBy({

        left: amount,

        behavior: "smooth"

      });

    }

  };


  var movePrevious = function() {

    var amount =
      getAmount();


    if (
      carousel.scrollLeft <= 5
    ) {

      carousel.scrollTo({

        left:
          carousel.scrollWidth -
          carousel.clientWidth,

        behavior: "smooth"

      });

    } else {

      carousel.scrollBy({

        left:
          -amount,

        behavior: "smooth"

      });

    }

  };


  var stopAutoScroll = function() {

    if (autoScrollTimer) {

      clearInterval(
        autoScrollTimer
      );

      autoScrollTimer = null;

    }

  };


  var startAutoScroll = function() {

    stopAutoScroll();


    autoScrollTimer =
      setInterval(
        function() {

          moveNext();

        },
        6000
      );

  };


  var restartAutoScroll = function() {

    stopAutoScroll();

    startAutoScroll();

  };


  if (nextBtn) {

    nextBtn.addEventListener(
      "click",
      function() {

        moveNext();

        restartAutoScroll();

      }
    );

  }


  if (prevBtn) {

    prevBtn.addEventListener(
      "click",
      function() {

        movePrevious();

        restartAutoScroll();

      }
    );

  }


  carousel.addEventListener(
    "mouseenter",
    stopAutoScroll
  );


  carousel.addEventListener(
    "mouseleave",
    startAutoScroll
  );


  startAutoScroll();

};


/* =========================================================
   SECTION SCROLL ANIMATION
   ========================================================= */

var initScrollAnimation = function(section) {

  if (
    window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches
  ) {

    section.classList.add(
      "is-visible"
    );

    return;

  }


  if (
    !("IntersectionObserver" in window)
  ) {

    section.classList.add(
      "is-visible"
    );

    return;

  }


  var rect =
    section.getBoundingClientRect();


  if (
    rect.top <
    window.innerHeight
  ) {

    requestAnimationFrame(
      function() {

        requestAnimationFrame(
          function() {

            section.classList.add(
              "is-visible"
            );

          }
        );

      }
    );

    return;

  }


  var observer =
    new IntersectionObserver(
      function(entries) {

        entries.forEach(
          function(entry) {

            if (
              entry.isIntersecting
            ) {

              section.classList.add(
                "is-visible"
              );


              observer.unobserve(
                section
              );

            }

          }
        );

      },
      {
        threshold: 0.1,

        rootMargin:
          "0px 0px -50px 0px"
      }
    );


  observer.observe(section);

};


/* =========================================================
   INITIAL LOAD
   ========================================================= */

document.addEventListener(
  "DOMContentLoaded",
  function() {

    loadProductRecommendationsIntoSection();

  }
);


/* =========================================================
   SHOPIFY SECTION LOAD
   ========================================================= */

document.addEventListener(
  "shopify:section:load",
  function(event) {

    var section =
      document.querySelector(
        '[data-section-id="' +
        event.detail.sectionId +
        '"].related-products'
      );


    if (section) {

      loadProductRecommendationsIntoSection();

    }

  }
);


/* =========================================================
   SHOPIFY SECTION UNLOAD
   ========================================================= */

document.addEventListener(
  "shopify:section:unload",
  function(event) {

    /*
      Shopify automatically removes
      the section from the DOM.
    */

  }
);


  } catch(e) { console.error(e); }
})();
})();
